export default {
  loadingError: {
    title: 'Error',
    message: 'Sorry, the application could not be loaded.',
    retryButton: 'Retry',
  },
};
